import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'login-failed',
    templateUrl: './login-failed.component.html',
    styleUrl: './login-failed.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LoginFailedComponent {
}